import { render } from "./home.vue?vue&type=template&id=5ef449c3&scoped=true&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=5ef449c3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef449c3"]])

export default __exports__